import React, { useState, useEffect } from 'react';
import { getPublicSettings, submitContact } from '../services/api';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { 
  FaLinkedinIn, FaFacebookF, FaInstagram, FaYoutube,
  FaMapMarkerAlt, FaEnvelope, FaPhone, FaArrowLeft, FaHome, 
  FaPaperPlane, FaSpinner, FaArrowRight, FaGlobe
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const Contact = () => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchContactData();
  }, []);

  const fetchContactData = async () => {
    try {
      const response = await getPublicSettings();
      console.log('Contact settings response:', response);
      
      let data = {};
      
      // Parse the response like footer
      if (response && response.data) {
        if (response.data.data && typeof response.data.data === 'object') {
          const outerData = response.data;
          const cleanData = {};
          Object.keys(outerData).forEach(key => {
            if (key !== 'data' && key !== 'success' && key !== 'message') {
              cleanData[key] = outerData[key];
            }
          });
          data = cleanData;
        } else {
          data = response.data;
        }
      } else if (response) {
        data = response;
      }
      
      console.log('Parsed contact settings:', data);
      setSettings(data);
      
    } catch (error) {
      console.error('Error fetching contact data:', error);
      // Fallback data
      setSettings({
        siteTitle: 'INTELIHEADS INTERNET Pvt. Ltd',
        tagline: 'AI & Robotics in Education',
        companyName: 'INTELIHEADS INTERNET Pvt. Ltd',
        contactEmail: 'global@inteliheads.com',
        email: 'info@inteliheads.in',
        phone: '+91-8076842489',
        address: 'Noida | USA',
        footerText: 'Uniting DIgSILENT, Ansys, MathWorks expertise to drive engineering breakthroughs worldwide.',
        copyrightText: `© ${new Date().getFullYear()} INTELIHEADS INTERNET Pvt. Ltd — Innovating Today & Empowering Tomorrow.`,
        socialLinks: '{"linkedin":"https://linkedin.com/company/inteliheads","twitter":"https://twitter.com/inteliheads","facebook":"https://facebook.com/inteliheads","instagram":"https://instagram.com/inteliheads","youtube":"https://youtube.com/inteliheads"}'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.message) {
      toast.error('Please fill in all required fields');
      return;
    }

    setSubmitting(true);
    try {
      const response = await submitContact(formData);
      console.log('Contact form submitted:', response);
      toast.success('Message sent successfully! We will contact you soon.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      console.error('Error sending message:', error);
      toast.error(error.message || 'Failed to send message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  // Get social links like footer
  const getSocialLinks = () => {
    try {
      if (settings.socialLinks) {
        const socialStr = typeof settings.socialLinks === 'string' 
          ? settings.socialLinks 
          : JSON.stringify(settings.socialLinks);
        return JSON.parse(socialStr);
      }
    } catch (e) {
      console.error('Error parsing social links:', e);
    }
    return { 
      linkedin: 'https://linkedin.com/company/inteliheads',
      twitter: 'https://twitter.com/inteliheads',
      facebook: 'https://facebook.com/inteliheads',
      instagram: 'https://instagram.com/inteliheads',
      youtube: 'https://youtube.com/inteliheads'
    };
  };

  const socialLinks = getSocialLinks();

  // Get data from settings with fallbacks like footer
  const companyName = settings.companyName || settings.siteTitle || 'INTELIHEADS INTERNET Pvt. Ltd';
  const tagline = settings.tagline || 'AI & Robotics in Education';
  const contactEmail = settings.contactEmail || settings.email || 'info@inteliheads.in';
  const phone = settings.phone || '+91-8076842489';
  const address = settings.address || 'Noida | USA';
  const footerText = settings.footerText || 'Uniting DIgSILENT, Ansys, MathWorks expertise to drive engineering breakthroughs worldwide.';

  const goBack = () => {
    navigate(-1);
  };

  const goHome = () => {
    navigate('/');
  };

  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
      }}>
        <FaSpinner className="fa-spin" style={{ fontSize: '2rem', color: '#2C7A7B' }} />
        <p style={{ marginLeft: '1rem', color: '#5A6E7F' }}>Loading contact info...</p>
      </div>
    );
  }

  return (
    <div style={{ 
      padding: '4rem 2rem', 
      background: '#F7F9FC', 
      minHeight: '100vh' 
    }}>
      <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Navigation Buttons */}
        <div style={{
          display: 'flex',
          gap: '1rem',
          marginBottom: '2rem',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={goBack}
            style={{
              padding: '0.6rem 1.2rem',
              background: 'white',
              border: '1px solid #E2E8F0',
              borderRadius: '10px',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              color: '#5A6E7F',
              transition: 'all 0.3s ease',
              fontWeight: 500
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#2C7A7B';
              e.currentTarget.style.color = 'white';
              e.currentTarget.style.borderColor = '#2C7A7B';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'white';
              e.currentTarget.style.color = '#5A6E7F';
              e.currentTarget.style.borderColor = '#E2E8F0';
            }}
          >
            <FaArrowLeft /> Back
          </button>
          
          <button
            onClick={goHome}
            style={{
              padding: '0.6rem 1.2rem',
              background: 'white',
              border: '1px solid #E2E8F0',
              borderRadius: '10px',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              color: '#5A6E7F',
              transition: 'all 0.3s ease',
              fontWeight: 500
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#2C7A7B';
              e.currentTarget.style.color = 'white';
              e.currentTarget.style.borderColor = '#2C7A7B';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'white';
              e.currentTarget.style.color = '#5A6E7F';
              e.currentTarget.style.borderColor = '#E2E8F0';
            }}
          >
            <FaHome /> Home
          </button>
        </div>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{
            fontSize: 'clamp(2rem, 5vw, 3rem)',
            color: '#0A192F',
            marginBottom: '0.5rem',
            fontWeight: 700
          }}>
            Contact Us
          </h1>
          <p style={{ color: '#5A6E7F', fontSize: '1.1rem' }}>
            Get in touch with us for any inquiries, support, or collaboration opportunities
          </p>
          <div style={{
            width: '80px',
            height: '3px',
            background: '#2C7A7B',
            margin: '1rem auto',
            borderRadius: '2px'
          }} />
        </div>

        {/* Main Content - Two Columns */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
          gap: '3rem',
          marginBottom: '3rem'
        }}>
          {/* LEFT COLUMN - Get in Touch (Contact Info) */}
          <div>
            <div style={{
              background: 'white',
              borderRadius: '20px',
              padding: '2rem',
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
              height: '100%'
            }}>
              <h2 style={{
                fontSize: '1.5rem',
                color: '#0A192F',
                marginBottom: '1.5rem',
                fontWeight: 700
              }}>
                Get in Touch
              </h2>
              <p style={{
                color: '#5A6E7F',
                lineHeight: '1.6',
                marginBottom: '2rem'
              }}>
                {footerText}
              </p>

              {/* Address - From Database */}
              <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '1rem',
                marginBottom: '1.5rem',
                padding: '1rem',
                background: '#F7F9FC',
                borderRadius: '12px'
              }}>
                <div style={{
                  width: '45px',
                  height: '45px',
                  background: '#2C7A7B',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  color: 'white',
                  fontSize: '1.2rem'
                }}>
                  <FaMapMarkerAlt />
                </div>
                <div>
                  <h4 style={{ color: '#0A192F', marginBottom: '0.25rem' }}>Address</h4>
                  <p style={{ color: '#5A6E7F', fontSize: '0.95rem', lineHeight: '1.5' }}>
                    {address}
                  </p>
                </div>
              </div>

              {/* Email - From Database */}
              <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '1rem',
                marginBottom: '1.5rem',
                padding: '1rem',
                background: '#F7F9FC',
                borderRadius: '12px'
              }}>
                <div style={{
                  width: '45px',
                  height: '45px',
                  background: '#2C7A7B',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  color: 'white',
                  fontSize: '1.2rem'
                }}>
                  <FaEnvelope />
                </div>
                <div>
                  <h4 style={{ color: '#0A192F', marginBottom: '0.25rem' }}>Email</h4>
                  <a href={`mailto:${contactEmail}`} style={{ 
                    color: '#2C7A7B', 
                    fontSize: '0.95rem',
                    textDecoration: 'none'
                  }}>
                    {contactEmail}
                  </a>
                </div>
              </div>

              {/* Phone - From Database */}
              <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '1rem',
                marginBottom: '1.5rem',
                padding: '1rem',
                background: '#F7F9FC',
                borderRadius: '12px'
              }}>
                <div style={{
                  width: '45px',
                  height: '45px',
                  background: '#2C7A7B',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  color: 'white',
                  fontSize: '1.2rem'
                }}>
                  <FaPhone />
                </div>
                <div>
                  <h4 style={{ color: '#0A192F', marginBottom: '0.25rem' }}>Phone</h4>
                  <a href={`tel:${phone}`} style={{ 
                    color: '#2C7A7B', 
                    fontSize: '0.95rem',
                    textDecoration: 'none'
                  }}>
                    {phone}
                  </a>
                </div>
              </div>

              {/* Website - From Database */}
              <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '1rem',
                padding: '1rem',
                background: '#F7F9FC',
                borderRadius: '12px',
                marginTop: '1.5rem'
              }}>
                <div style={{
                  width: '45px',
                  height: '45px',
                  background: '#2C7A7B',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  color: 'white',
                  fontSize: '1.2rem'
                }}>
                  <FaGlobe />
                </div>
                <div>
                  <h4 style={{ color: '#0A192F', marginBottom: '0.25rem' }}>Website</h4>
                  <a href="https://inteliheads.in" target="_blank" rel="noopener noreferrer" style={{ 
                    color: '#2C7A7B', 
                    fontSize: '0.95rem',
                    textDecoration: 'none'
                  }}>
                    https://inteliheads.in
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN - Send Us a Message (Contact Form) */}
          <div>
            <div style={{
              background: 'white',
              borderRadius: '20px',
              padding: '2rem',
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
            }}>
              <h2 style={{
                fontSize: '1.5rem',
                color: '#0A192F',
                marginBottom: '1.5rem',
                fontWeight: 700
              }}>
                Send Us a Message
              </h2>

              <form onSubmit={handleSubmit}>
                {/* Name */}
                <div style={{ marginBottom: '1.2rem' }}>
                  <label style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: 500,
                    color: '#0A192F'
                  }}>
                    Full Name <span style={{ color: '#DC2626' }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Enter your full name"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #E2E8F0',
                      borderRadius: '10px',
                      fontSize: '0.95rem',
                      transition: 'border-color 0.2s'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#2C7A7B'}
                    onBlur={(e) => e.target.style.borderColor = '#E2E8F0'}
                  />
                </div>

                {/* Email */}
                <div style={{ marginBottom: '1.2rem' }}>
                  <label style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: 500,
                    color: '#0A192F'
                  }}>
                    Email Address <span style={{ color: '#DC2626' }}>*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Enter your email address"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #E2E8F0',
                      borderRadius: '10px',
                      fontSize: '0.95rem',
                      transition: 'border-color 0.2s'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#2C7A7B'}
                    onBlur={(e) => e.target.style.borderColor = '#E2E8F0'}
                  />
                </div>

                {/* Phone */}
                <div style={{ marginBottom: '1.2rem' }}>
                  <label style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: 500,
                    color: '#0A192F'
                  }}>
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter your phone number"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #E2E8F0',
                      borderRadius: '10px',
                      fontSize: '0.95rem',
                      transition: 'border-color 0.2s'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#2C7A7B'}
                    onBlur={(e) => e.target.style.borderColor = '#E2E8F0'}
                  />
                </div>

                {/* Subject */}
                <div style={{ marginBottom: '1.2rem' }}>
                  <label style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: 500,
                    color: '#0A192F'
                  }}>
                    Subject
                  </label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Enter subject"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #E2E8F0',
                      borderRadius: '10px',
                      fontSize: '0.95rem',
                      transition: 'border-color 0.2s'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#2C7A7B'}
                    onBlur={(e) => e.target.style.borderColor = '#E2E8F0'}
                  />
                </div>

                {/* Message */}
                <div style={{ marginBottom: '1.5rem' }}>
                  <label style={{
                    display: 'block',
                    marginBottom: '0.5rem',
                    fontWeight: 500,
                    color: '#0A192F'
                  }}>
                    Message <span style={{ color: '#DC2626' }}>*</span>
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Write your message here..."
                    rows="5"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #E2E8F0',
                      borderRadius: '10px',
                      fontSize: '0.95rem',
                      resize: 'vertical',
                      transition: 'border-color 0.2s',
                      fontFamily: 'inherit'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#2C7A7B'}
                    onBlur={(e) => e.target.style.borderColor = '#E2E8F0'}
                  />
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={submitting}
                  style={{
                    width: '100%',
                    padding: '0.9rem',
                    background: submitting ? '#5A6E7F' : '#2C7A7B',
                    color: 'white',
                    border: 'none',
                    borderRadius: '12px',
                    fontSize: '1rem',
                    fontWeight: 600,
                    cursor: submitting ? 'not-allowed' : 'pointer',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem'
                  }}
                  onMouseEnter={(e) => {
                    if (!submitting) {
                      e.currentTarget.style.background = '#236B6C';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!submitting) {
                      e.currentTarget.style.background = '#2C7A7B';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }
                  }}
                >
                  {submitting ? (
                    <>
                      <FaSpinner className="fa-spin" /> Sending...
                    </>
                  ) : (
                    <>
                      <FaPaperPlane /> Send Message
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Social Media Section - Full Width Bottom */}
        <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '2rem',
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
          marginTop: '1rem'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '1.5rem'
          }}>
            <div>
              <h3 style={{
                fontSize: '1.2rem',
                color: '#0A192F',
                fontWeight: 700
              }}>
                Connect With Us
              </h3>
              <p style={{ color: '#5A6E7F', fontSize: '0.9rem', marginTop: '0.25rem' }}>
                Follow us on social media for updates and news
              </p>
            </div>
            
            <div style={{ display: 'flex', gap: '0.8rem', flexWrap: 'wrap' }}>
              {/* LinkedIn */}
              {socialLinks.linkedin && socialLinks.linkedin !== '#' && (
                <a 
                  href={socialLinks.linkedin} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.6rem',
                    padding: '0.5rem 1rem',
                    background: '#0077B5',
                    borderRadius: '10px',
                    color: 'white',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    fontSize: '0.85rem'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,119,181,0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <FaLinkedinIn />
                  <span>LinkedIn</span>
                </a>
              )}
              
              {/* Twitter/X */}
              {socialLinks.twitter && socialLinks.twitter !== '#' && (
                <a 
                  href={socialLinks.twitter} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.6rem',
                    padding: '0.5rem 1rem',
                    background: '#000000',
                    borderRadius: '10px',
                    color: 'white',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    fontSize: '0.85rem'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <FaXTwitter />
                  <span>Twitter / X</span>
                </a>
              )}
              
              {/* Facebook */}
              {socialLinks.facebook && socialLinks.facebook !== '#' && (
                <a 
                  href={socialLinks.facebook} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.6rem',
                    padding: '0.5rem 1rem',
                    background: '#1877F2',
                    borderRadius: '10px',
                    color: 'white',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    fontSize: '0.85rem'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(24,119,242,0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <FaFacebookF />
                  <span>Facebook</span>
                </a>
              )}
              
              {/* Instagram */}
              {socialLinks.instagram && socialLinks.instagram !== '#' && (
                <a 
                  href={socialLinks.instagram} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.6rem',
                    padding: '0.5rem 1rem',
                    background: '#E4405F',
                    borderRadius: '10px',
                    color: 'white',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    fontSize: '0.85rem'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(228,64,95,0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <FaInstagram />
                  <span>Instagram</span>
                </a>
              )}
              
              {/* YouTube */}
              {socialLinks.youtube && socialLinks.youtube !== '#' && (
                <a 
                  href={socialLinks.youtube} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.6rem',
                    padding: '0.5rem 1rem',
                    background: '#FF0000',
                    borderRadius: '10px',
                    color: 'white',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    fontSize: '0.85rem'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(255,0,0,0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <FaYoutube />
                  <span>YouTube</span>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;